import { connectStats } from 'instantsearch.js/es/connectors'

const renderStats = (renderOptions, isFirstRender) => {
  const { nbHits, widgetParams } = renderOptions
  let text = ''

  if (widgetParams.container) {
    if (widgetParams.type === 'training') {
      if (nbHits > 0) {
        text = `${nbHits > 1 ? 'Nos' : ''} ${nbHits} formation${nbHits > 1 ? 's' : ''} au catalogue`
      } else {
        text = 'Formations au catalogue'
      }
    } else if (widgetParams.type === 'search') {
      text = nbHits > 1 ? `${nbHits} ${config.trads['search.plural']}` : `${nbHits} ${config.trads['search.singular']}`
    } else {
      if (nbHits > 0) {
        text = `${nbHits} ${nbHits > 1 ? config.trads[`list.${widgetParams.type}.plural`] : config.trads[`list.${widgetParams.type}.singular`]}`
      } else {
        text = config.trads[`list.${widgetParams.type}.plural`]
      }
    }

    widgetParams.container.innerHTML = text
  }

  if (widgetParams.nbHitsPerPage) {
    if (nbHits > widgetParams.nbHitsPerPage) {
      widgetParams.pagination.classList.remove('is-hidden')
    } else {
      widgetParams.pagination.classList.add('is-hidden')
    }
  }

  if (widgetParams.numberItems) {
    widgetParams.numberItems.forEach((item) => {
      if (item.dataset && item.dataset.type && item.dataset.type === 'mobile') {
        item.innerHTML = nbHits
      } else {
        if (widgetParams.type === 'training') {
          item.innerHTML = `${nbHits} formation${nbHits > 1 ? 's' : ''}`
        } else {
          item.innerHTML = `${nbHits} ${nbHits > 1 ? config.trads[`list.${widgetParams.type}.plural`] : config.trads[`list.${widgetParams.type}.singular`]}`
        }
      }
    })
  }
}

const customStats = connectStats(renderStats)

export default customStats
